//components
import { FormControl, FormHelperText, InputLabel } from "@mui/material";
import Select from "@mui/material/Select";

//translations and messages
import { FormattedMessage } from "react-intl";

import classes from "./SelectField.module.scss";
import { getMessageProps } from "../../utils/utils";

interface ISelectFieldUI {
  children: JSX.Element | JSX.Element[];
  input: any;
  label: JSX.Element | JSX.Element[];
  meta: any;
  changeForm: any;
  valueForm: string;
  messages: any;
  selectType: any;
}

const SelectFieldUI = (props: ISelectFieldUI) => {
  const {
    input,
    label,
    meta,
    children,
    changeForm,
    valueForm,
    messages,
    selectType,
  } = props;
  const { touched, error } = meta;

  const handleChange = (event: any) => {
    changeForm(input.name, event.target.value);
  };

  return (
    <FormControl variant="filled" fullWidth>
      <InputLabel
        className={classes["select-ui-filled-field-label"]}
        id={`${input.name}-select-label`}
        variant="filled"
      >
        {label}
      </InputLabel>
      <Select
        className={classes["select-ui-filled-field"]}
        labelId={`${input.name}-select-label`}
        id={`${input.name}-select-id`}
        label={label}
        value={valueForm || ""}
        renderValue={(value: string | number | any) => {
          const messageKey = selectType?.[value];
          if (messageKey) {
            return (
              <FormattedMessage
                {...getMessageProps(messages, messageKey as string)}
              />
            );
          }
        }}
        onChange={handleChange}
      >
        {children}
      </Select>
      {touched && error && <FormHelperText> Error</FormHelperText>}
    </FormControl>
  );
};

export default SelectFieldUI;
